import { useQuery } from 'react-query';
import { useProfileRepository } from '~/adapters/services/profiles/profile/rest';
import { useAuth, useOptionalAuth } from '~/contexts/Auth/AuthContext';

export function useUserProfilesData() {
    const auth = useOptionalAuth();
    const { getMyUserData } = useProfileRepository();

    return useQuery(
        ['user-profiles-data'],
        async () => {
            const response = await getMyUserData();
            return response;
        },
        {
            enabled: auth?.identityProvider === 'profiles',
        },
    );
}

export function useIsEmailVerified() {
    const auth = useAuth();
    const { isLoading, data } = useUserProfilesData();

    // when using auth0 flow, user is always verified
    const isEmailVerified = auth.identityProvider === 'auth0' || data?.confirmed;

    return {
        isLoading,
        isEmailVerified,
    };
}

export function useHasPassword() {
    const { isLoading, data } = useUserProfilesData();

    return {
        isLoading,
        hasPassword: data?.has_password,
    };
}
